import { onUnmounted } from 'vue';
import { Handler } from 'mitt';

import emitter from '@/utils/eventbus';


export const useEventBus = () => {
  const eventCollector = {
    eventMap: new Map(),
    add(key: string, cb: Handler<any>) {
      let handlers = this.eventMap.get(key);
      if (!handlers) {
        handlers = [];
      }
      handlers.push(cb);
      this.eventMap.set(key, handlers);
    },
    clear() {
      this.eventMap.forEach((list, key) => {
        list.forEach((cb: Handler<any>) => {
          emitter.off(key, cb);
        });
      });
      this.eventMap.clear();
    }
  };

  const emitterOn = emitter.on.bind(emitter);

  emitter.on = (key: string, cb: Handler<any>) => {
    emitterOn(key, cb);
    eventCollector.add(key, cb);
  };


  onUnmounted(() => {
    eventCollector.clear();
  });
  return emitter;
};